import { render, staticRenderFns } from "./postCode.vue?vue&type=template&id=7162d7ae&scoped=true"
import script from "./postCode.vue?vue&type=script&lang=js"
export * from "./postCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7162d7ae",
  null
  
)

export default component.exports